import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== pw2) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated! Please sign in.");
      nav("/login");
    } catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };

  if (!token) {
    return (
      <div className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-4 py-10 text-center">
        <p className="text-slate-600">This reset link is invalid or incomplete.</p>
        <Link to="/forgot-password" className="mt-3 font-bold text-brand">Request a new link</Link>
      </div>
    );
  }

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-4 py-10">
      <div className="rounded-3xl border border-slate-200 bg-white p-7 shadow-sm">
        <h1 className="font-head text-2xl font-black text-slate-900">Set a new password</h1>
        <p className="mt-1 text-sm text-slate-500">Choose a strong password you'll remember.</p>
        <form onSubmit={submit} className="mt-5 space-y-3">
          <div className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 focus-within:border-brand">
            <Lock className="h-4 w-4 text-slate-400" />
            <input value={pw} onChange={(e) => setPw(e.target.value)} type="password" required placeholder="New password"
              data-testid="reset-password" className="w-full bg-transparent py-2.5 text-sm outline-none" />
          </div>
          <div className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 focus-within:border-brand">
            <Lock className="h-4 w-4 text-slate-400" />
            <input value={pw2} onChange={(e) => setPw2(e.target.value)} type="password" required placeholder="Confirm new password"
              data-testid="reset-password-confirm" className="w-full bg-transparent py-2.5 text-sm outline-none" />
          </div>
          <button type="submit" disabled={busy} data-testid="reset-submit"
            className="w-full rounded-xl bg-brand py-2.5 text-sm font-bold text-white hover:bg-brand-deep disabled:opacity-60">
            {busy ? "Updating…" : "Update password"}
          </button>
        </form>
        <Link to="/login" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-brand"><ArrowLeft className="h-4 w-4" /> Back to sign in</Link>
      </div>
    </div>
  );
}
